import { render } from "./Profile.vue?vue&type=template&id=77435a4b&scoped=true&bindings={\"email\":\"setup\"}"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=77435a4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77435a4b"

export default script